import paths from '~/constants/paths';

const SET_CUSTOMER = 'set_customer';
const UPDATE_SETTINGS = 'update_settings';
const SET_DEFAULT_DELIVERY_ADDRESS = 'set_default_delivery_address';

const state = () => ({
  customer: null,
});

const actions = {
  fetchCurrentCustomer ({ commit, rootState }) {
    return this.$getDataProvider(paths.customers)
      .getOne('', { uuid: rootState.account.user.uuid })
      .then((response) => commit(SET_CUSTOMER, response.data));
  },

  setDefaultAddress ({ commit, dispatch, rootState }, address) {
    const user = rootState.account.user;
    const currentCompany = user.currentCompany;
    let endpoint = paths.companies;
    let uuid = currentCompany;

    if (currentCompany === null) {
      uuid = user.uuid;
      endpoint = paths.customers;
      const customer = rootState.customers.customer;
      const defaultDeliveryAddress = customer.currentDefaultDeliveryAddress;
      if (defaultDeliveryAddress !== null && defaultDeliveryAddress.uuid === address.uuid) {
        return Promise.resolve('rejected');
      }
    }

    const iriUrl = `${paths.api}${paths.addresses}/`;
    const setup = {
      uuid,
      data: {
        defaultDeliveryAddress: iriUrl + address.uuid,
      },
    };

    return this.$getDataProvider(endpoint)
      .update('', setup)
      .then((response) => {
        commit(SET_DEFAULT_DELIVERY_ADDRESS, { response });

        dispatch('addresses/fetchAddresses', {}, { root: true });
        dispatch('customers/fetchCurrentCustomer', {}, { root: true });

        return response;
      })
      .catch((error) => {
        throw error.response;
      });
  },

  update ({ commit, rootState }, { customer, address, addressIntend }) {
    const uuid = rootState.account.user.uuid;
    const customerUpdated = this.$getDataProvider(paths.customers)
      .update('', {
        data: customer,
        uuid,
      })
      .then(({ data }) => {
        commit(UPDATE_SETTINGS, data);

        return data;
      });

    let addressCreatedOrUpdated;
    if (addressIntend === 'create') {
      const newAddress = { ...address };
      newAddress.mainAddress = true;

      // Todo: Address model property 'country' is object instead of string
      newAddress.country = typeof address.country === 'object'
        ? address.country.code
        : address.country;
      const customersPath = `${paths.api}${paths.customers}/`;
      newAddress.customer = `${customersPath}${rootState.account.user.uuid}`;

      addressCreatedOrUpdated = this.$getDataProvider(paths.addresses)
        .create('', { data: newAddress })
        .then(({ data }) => {
          return data;
        });
    } else {
      addressCreatedOrUpdated = this.$getDataProvider(paths.addresses)
        .update('', { data: address, uuid: address.uuid })
        .then(({ data }) => {
          return data;
        });
    }

    return Promise
      .all([customerUpdated, addressCreatedOrUpdated])
      .then((response) => {
        const [customerData, addressData] = response;

        const ADDRESS_MUTATION = addressIntend === 'create'
          ? 'addresses/create_address'
          : 'addresses/update_address';

        commit(UPDATE_SETTINGS, customerData, { root: true });
        commit(ADDRESS_MUTATION, addressData, { root: true });
      });
  },

  // eslint-disable-next-line no-empty-pattern
  resetPassword ({}, payload) {
    return this.$getDataProvider(paths.customers)
      .create('', {
        action: 'password-reset-mail',
        data: payload,
      });
  },
};

const mutations = {
  [SET_CUSTOMER] (state, customer) {
    state.customer = customer;
  },

  [SET_DEFAULT_DELIVERY_ADDRESS] (state, { response }) {
    state.customer.currentDefaultDeliveryAddress = response.data.currentDefaultDeliveryAddress;
  },

  [UPDATE_SETTINGS] (state, customer) {
    state.customer = customer;
  },
};

const getters = {
  getCustomer (state) {
    return state.customer;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
